import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarAutorizacaoPrevia } from './types';

export const INITIAL_STATE: consultarAutorizacaoPrevia = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarAutorizacaoPrevia {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_AUTORIZACAO_PREVIA_REQUEST: {
				break;
			}

			case Types.CONSULTAR_AUTORIZACAO_PREVIA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_AUTORIZACAO_PREVIA_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTAR_AUTORIZACAO_PREVIA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
